import { createSelector } from 'reselect';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_RS_ADD_STEPS } from '@Pages/RetroSynthesis/EditPlan/AddSteps/constants';
import {
  databases as databasesSelector,
  reaxysDatabaseId as reaxysDatabaseIdSelector,
} from '@Services/UserDatabases/UserDatabasesSelectors';

export const rsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);
export const addStepsState = (state) => rsState(state).get(REDUCER_KEY_RS_ADD_STEPS);
export const addStepsDialogIsShown = (state) => addStepsState(state).addStepsDialogIsShown;
export const selectedStep = (state) => addStepsState(state).selectedStep;

export const publishedResponse = (state) => addStepsState(state).publishedResponse;

export const getSelectedStepsData = (state) => {
  return addStepsState(state).selectedStepsData;
};

export const predictedResponse = (state) => addStepsState(state).predictedResponse;

export const selectedItemsByTab = (state) => addStepsState(state).selectedItemsByTab;

// In-house
export const isInHouseLoadingByDatabase = (state) => addStepsState(state).isInHouseLoadingByDatabase;
export const inHouseResponseByDatabase = (state) => addStepsState(state).inHouseResponseByDatabase;
export const inHouseDatabases = createSelector([databasesSelector, reaxysDatabaseIdSelector], (databases, reaxysDatabaseId) => {
  return databases
    .filter(
      (db) => db.get('availableContexts').some((context) => context.get('serverAlias') === 'reactions') && db.get('id') !== reaxysDatabaseId
    )
    .sort((db) => db.get('priority'))
    .map((inHouseDb) => ({
      name: inHouseDb.get('name'),
      id: inHouseDb.get('id'),
    }))
    .valueSeq()
    .toArray();
});
